import { render } from "./doughnut_chart.vue?vue&type=template&id=1f1a2274"
import script from "./doughnut_chart.vue?vue&type=script&lang=js"
export * from "./doughnut_chart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/components/chart/doughnut_chart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f1a2274"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f1a2274', __exports__)) {
    api.reload('1f1a2274', __exports__)
  }
  
  module.hot.accept("./doughnut_chart.vue?vue&type=template&id=1f1a2274", () => {
    api.rerender('1f1a2274', render)
  })

}


export default __exports__